"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = void 0;
const react_1 = __importDefault(require("react"));
// fixme it's dependency used there and in radio-group
const FormGroup_1 = __importDefault(require("react-bootstrap/FormGroup"));
const FormLabel_1 = __importDefault(require("react-bootstrap/FormLabel"));
const react_2 = require("../../types/react");
const classFunctions_1 = require("../../utils/classFunctions");
const flatArray_1 = require("../../utils/flatArray");
const Icon_1 = require("../Icon");
require("./index.scss");
const className = 'checkbox';
/** @deprecated Use CheckBoxStable */
exports.CheckBox = (0, react_2.withRef)((props, ref) => {
    const { error, text, textLeft, modificators, hidden, ...restProps } = props;
    const errorElements = (0, flatArray_1.flatArray)(error);
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        errorElements ? 'error' : undefined,
    ]);
    const containerClassNames = (0, classFunctions_1.getClassNames)(`${className}__container`, [
        restProps.disabled ? 'disabled' : undefined,
    ]);
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(FormGroup_1.default, null,
            react_1.default.createElement(FormLabel_1.default, { className: containerClassNames },
                react_1.default.createElement("input", { ...restProps, className: `${className}__value`, ref: ref, type: 'checkbox' }),
                textLeft ? (react_1.default.createElement("span", { className: `${className}__text` }, textLeft)) : null,
                react_1.default.createElement("span", { "data-target": 'checkbox', className: `${className}__icon` },
                    react_1.default.createElement(Icon_1.Icon, { name: 'check-mark' })),
                text ? (react_1.default.createElement("span", { className: `${className}__text` }, text)) : null))));
});
//# sourceMappingURL=index.js.map